import { render, staticRenderFns } from "./NonConformityProfileCard.vue?vue&type=template&id=b0512258&scoped=true&"
import script from "./NonConformityProfileCard.vue?vue&type=script&lang=js&"
export * from "./NonConformityProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0512258",
  null
  
)

export default component.exports